module.exports = __webpack_public_path__ + "img/logo-recoma.953e57b1.png";